import { Heart, Search, HandHeart, UsersRound } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

const steps = [
  { icon: Search, title: "Znajdź schronisko", desc: "Szukaj po lokalizacji lub nazwie", highlight: false },
  { icon: Heart, title: "Sprawdź potrzeby", desc: "Zobacz, czego aktualnie potrzebują", highlight: false },
  { icon: HandHeart, title: "Pomóż!", desc: "Przywieź dary lub skontaktuj się", highlight: false },
  { icon: UsersRound, title: "Podziel się info", desc: "Dodaj brakujące info lub udostępnij 💚", highlight: true },
];

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost3Timeline = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "40px",
        }}
      >
        {/* Header - centered */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <p
            style={{
              fontSize: "26px",
              fontWeight: 600,
              color: "#4E8A6E",
              margin: "0 0 8px 0",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            Chcesz pomóc?
          </p>
          <h1
            style={{
              fontSize: "64px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.1,
            }}
          >
            To proste! ✨
          </h1>
        </div>

        {/* Timeline */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0",
            position: "relative",
          }}
        >
          {/* Vertical line - centered through circles */}
          <div
            style={{
              position: "absolute",
              left: "32px",
              top: "44px",
              bottom: "44px",
              width: "4px",
              background: "linear-gradient(180deg, #4E8A6E 0%, #8B5CF6 100%)",
              borderRadius: "2px",
              transform: "translateX(-50%)",
            }}
          />

          {steps.map((s, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                padding: "12px 0",
              }}
            >
              {/* Number circle */}
              <div
                style={{
                  width: "72px",
                  height: "72px",
                  background: s.highlight 
                    ? "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)"
                    : "linear-gradient(135deg, #4E8A6E 0%, #3D7A5E 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: s.highlight 
                    ? "0 8px 24px rgba(139, 92, 246, 0.35)" 
                    : "0 8px 24px rgba(78, 138, 110, 0.3)",
                  zIndex: 1,
                  flexShrink: 0,
                }}
              >
                <span style={{ fontSize: "32px", fontWeight: 800, color: "#FFFFFF" }}>
                  {i + 1}
                </span>
              </div>

              {/* Content card - matching Post3 style */}
              <div
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "24px",
                  padding: "24px 32px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  boxShadow: s.highlight 
                    ? "0 6px 24px rgba(139,92,246,0.25)" 
                    : "0 4px 20px rgba(0,0,0,0.06)",
                  border: s.highlight ? "3px solid #8B5CF6" : "none",
                  flex: 1,
                  maxWidth: "640px",
                }}
              >
                {/* Icon */}
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    background: s.highlight 
                      ? "#F3E8FF" 
                      : "linear-gradient(135deg, #E8F5EA 0%, #D4EED8 100%)",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <s.icon style={{ width: "28px", height: "28px", color: s.highlight ? "#8B5CF6" : "#4E8A6E" }} />
                </div>

                <div style={{ textAlign: "left" }}>
                  <h3 style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                    {s.title}
                  </h3>
                  <p style={{ fontSize: "20px", color: "#6B8A7A", margin: "4px 0 0", fontWeight: 500, whiteSpace: "nowrap" }}>
                    {s.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </GraphicBackground>
  );
};

